import { Container, Typography } from "@mui/material";
import { useIntl } from "react-intl";

export const AccountNotFoundPage = () => {
  const { formatMessage: t } = useIntl();

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" gutterBottom>
        {t({ id: "knowfullyAdmin" })}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t({ id: "youDontHaveAccount" })}
      </Typography>
      <Typography variant="body1">
        {t({ id: "accountNotFoundHelp" })}
      </Typography>
    </Container>
  );
};
